import { createBrowserRouter } from "react-router-dom";
import { APP__ROUTES } from "../../shared/consts";
import Payment from "../../pages/Payment/index";
import { DepositeForm } from "../../pages/Payment/ui/DepositeForm";

const router = createBrowserRouter([
  {
    path: APP__ROUTES.main,
    element: <Payment />,
    children: [
      {
        path: APP__ROUTES.offer,
        element: <></>,
      },
    ],
  },
  {
    path: APP__ROUTES.test,
    element: <DepositeForm />,
  },
]);
export default router;
